// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.yTh,
.custom-table th {
  background-color: #f2f2f2;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.top-header {
  background-color: #939090 !important; /* Optional: Different background for 'ABC' row */
  font-weight: bold; /* Keeps 'ABC' text normal if desired */
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/main/agent/performance-page.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,sBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,oCAAA,EAAA,iDAAA;EACA,iBAAA,EAAA,uCAAA;EACA,kBAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
